import React, {Component} from 'react';
import { translate } from 'react-i18next';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

import {initNavbarState} from 'actions/navbar.js';
import {fetchTeamChallengeLeaderboards} from 'actions/leaderboards.js';
import {getTeamChallengeLeaderboards, getTeamChallengeInfo} from 'reducers/leaderboards.js';
import {NavControl} from 'modules/navigation/NavBarContainer.js';
import Challenge from 'modules/challenges/Challenge.js';
import DatabaseService from 'services/DatabaseService.js';

import ChallengeInvitations from './ChallengeInvitations.js';
import ChallengeActive from './ChallengeActive.js';
import ChallengeHistory from './ChallengeHistory.js';

const Titles={
    invitations: 'Pending Invitations',
    active:      'Active Sessions',
    history:     'Challenge History',
};

const Params={
    invitations: {accepted:false, completed:false},
    active:      {accepted:true,  completed:false},
    history:     {accepted:true,  completed:true, userChallenges:true},
}

const getAvatars = challengeRecord => challengeRecord.challengeRecordMembers.map(crm=>crm.userProfile.avatar&&crm.userProfile.avatar.url);

class MyTeamContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {busy:false, members:null};
        this.onStartChallenge = this.onStartChallenge.bind(this);
        this.onCloseChallenge= this.onCloseChallenge.bind(this);
        this.onDeclineInvitation = this.onDeclineInvitation.bind(this);
        this.onViewStatus= this.onViewStatus.bind(this);
    }

    componentWillMount() {
        this.initNavigation();
        this.loadData();
    }

    initNavigation() {
        var title = this.props.t(Titles[this.props.mode]) || '';
        this.props.dispatch(initNavbarState({enable:true, menuEnable:false, backButtonEnable:true, rewardsEnable:false, title:title}));
        this.props.dispatch({type:'SET_SIDEBAR_ENABLE', enable:false});
    }

    loadData() {
        this.setState({busy:true});
        var params = Params[this.props.mode];
        params.start = 0;
        params.limit = 10;
        DatabaseService.fetchTeamChallengeMembers(params)
            .then((result)=> {
                this.setState({members:result.members});
            })
            .catch((error)=> {
                console.error('ERROR:');
                console.error(error);
            })
            .then(()=>{
                this.setState({busy:false});
            });
    }

    onDeclineInvitation(recordId) {
        this.props.dispatch({type:"SET_LOADING_OVERLAY_ENABLE", enable:true});
        DatabaseService.declineTeamChallengeInvitation(recordId).then((result) => {
                this.loadData();
            }).catch((error)=>{
                console.error("error - declineTeamChallengeInvitation", error);
            })
            .then(()=>{
                this.props.dispatch({type:"SET_LOADING_OVERLAY_ENABLE", enable:false});
            });
    }

    onViewStatus(challengeRecord) {
        this.props.history.push('/team-challenges/'+challengeRecord.id);
    }

    onStartChallenge(challengeRecord) {
        this.setState({selectedChallengeRecord:challengeRecord});
    }

    onCloseChallenge() {
        this.setState({selectedChallengeRecord:null});
        this.initNavigation();
    }

    renderChallenge() {
        var challengeRecord = this.state.selectedChallengeRecord;
        var challengeId = challengeRecord.challenge.id;
        var challengeRecordId = challengeRecord.id;

        var userProfiles = challengeRecord.challengeRecordMembers.map(crm => crm.userProfile);

        var teamChallengeData = {
            userProfiles:userProfiles,
            leaderboard:challengeRecord.leaderboard
        };
        return (
            <NavControl key="teamchallenge" onClose={this.onCloseChallenge} closeIconOpts={{key:'teamchallenge', name:'chevron left'}}>
                <Challenge challengeId={challengeId} 
                           challengeRecordId={challengeRecordId}
                           teamChallengeData={teamChallengeData} />
            </NavControl>
        );
    }

    renderInvitations() {
        return <ChallengeInvitations busy={this.state.busy}
                                 members={this.state.members}
                                 onStartChallenge={this.onStartChallenge}
                                 onDeclineInvitation={this.onDeclineInvitation}
                                 getAvatars={getAvatars}
                                 />;
    }
    renderActive() {
        return <ChallengeActive  busy={this.state.busy}
                                 members={this.state.members}
                                 getAvatars={getAvatars}
                                 onViewStatus={this.onViewStatus}
                                 me={this.props.me}
                                 />;
    }
    renderHistory() {
        return <ChallengeHistory busy={this.state.busy}
                                 members={this.state.members}
                                 getAvatars={getAvatars}
                                 onViewStatus={this.onViewStatus}
                                 me={this.props.me}
                                 />;
    }

    render() {
        if(this.state.selectedChallengeRecord) {
            return this.renderChallenge();
        }
        switch(this.props.mode) {
            case 'invitations': return this.renderInvitations();
            case 'active'     : return this.renderActive();
            case 'history'    : return this.renderHistory();
            default           : return null;
        }
    }
}


const mapStateToProps = (state) => {
    return {me:state.user.userProfile,
            leaderboards:getTeamChallengeLeaderboards(state.leaderboards),
            teamChallengeInfo:getTeamChallengeInfo(state.leaderboards)};
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(translate('teamchallenges')(MyTeamContainer)));



// WEBPACK FOOTER //
// ./src/modules/teamchallenges/MyTeamContainer.js